import React, { useCallback, useEffect, useRef } from 'react'

import { enterBooking } from '../../lib/booking-entry'
import { wireCoverageCheck } from '../../lib/coverage-check'

// "DO WE COVER YOU?" on /services, which React draws. The same markup and
// classes as the wash pages' server partial (app/views/gwmc/_coverage_check),
// and the same answer: lib/coverage-check asks GET /coverage and puts the
// server's own `html` (words and Book button) under the box. React never
// draws inside [data-coverage-answer]; the Book button in it goes through
// enterBooking() like every other one, as `coverage_check`.
const isPlainClick = event =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey

export const CoverageCheck = ({ className }) => {
  const root = useRef(null)

  useEffect(() => wireCoverageCheck(root.current), [])

  const onClick = useCallback(event => {
    const link = event.target.closest && event.target.closest('a[data-booking-source]')
    if (!link || !isPlainClick(event)) return
    event.preventDefault()
    enterBooking(link.dataset.bookingSlug || null, link.dataset.bookingSource, {
      extra: link.dataset.bookingExtra || undefined
    })
  }, [])

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div ref={root} id="coverage" className={['coverage', className].filter(Boolean).join(' ')} data-coverage-check="" onClick={onClick}>
      <form className="coverage-form" action="/services" method="get" noValidate>
        <label className="coverage-label" htmlFor="coverage-postcode">Do we cover you?</label>
        <div className="coverage-ask">
          <input
            id="coverage-postcode"
            className="coverage-input"
            name="postcode"
            placeholder="e.g. SW6 1RE"
            autoCapitalize="characters"
            autoComplete="postal-code"
            spellCheck={false}
            enterKeyHint="go"
          />
          <button className="gwmc-btn gwmc-btn--secondary coverage-go" type="submit">Check</button>
        </div>
      </form>
      <div className="coverage-answer" aria-live="polite" data-coverage-answer="" />
    </div>
  )
}
